module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "chapter-no",
    attrs: {
      "id": "ch-1"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_1"
    }
  }, [_c('strong', [_vm._v("CHAPTER 1")])])]), _c('a', {
    attrs: {
      "id": "page_1"
    }
  }, [_c('h1', {
    staticClass: "chapter-title"
  }, [_vm._v("Preaching Christ and Preaching the Old Testament")]), _vm._v(" "), _c('p', {
    staticClass: "epigraph"
  }, [_vm._v("“We preach Christ crucified …, Christ the power of God and the wisdom of God.”")]), _vm._v(" "), _c('p', {
    staticClass: "epigraph-author"
  }, [_vm._v("Paul, 1 Corinthians 1:23-24 (NIV)")])]), _c('p', {
    staticClass: "para"
  }, [_c('a', {
    attrs: {
      "id": "page_1"
    }
  }, [_c('span', {
    staticClass: "big"
  }, [_vm._v("T"), _c('span', {
    staticClass: "smallcaps1"
  }, [_vm._v("HIS BOOK")])]), _vm._v(" deals with preaching Christ from the Old Testament. Before we turn our attention specifically to this topic, we need to lay the foundations on which to build subsequently. In this opening chapter, we shall discuss two distinct topics: (1) the necessity of preaching "), _c('em', [_vm._v("Christ,")]), _vm._v(" and (2) the necessity of preaching from the "), _c('em', [_vm._v("Old Testament.")]), _vm._v(" In ")]), _c('span', {
    attrs: {
      "href": "#/009_Chapter02#ch-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 2")]), _vm._v(" we shall merge the results of our discoveries as we discuss the necessity of preaching "), _c('em', [_vm._v("Christ from the Old Testament")]), _vm._v(".")]), _vm._v(" "), _c('h1', {
    staticClass: "sec1",
    attrs: {
      "id": "sec-1"
    }
  }, [_c('strong', [_vm._v("THE NECESSITY OF PREACHING CHRIST")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Homileticians from a wide variety of Christian traditions advocate the preaching of Christ. For example, the Roman Catholic author Domenico Grasso states, “The object and content of preaching is Christ, the Word in which the Father expresses Himself and communicates His will to man.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn1",
      "id": "fn-1"
    }
  }, [_vm._v("1")])]), _vm._v(" The Eastern Orthodox Georges Florovsky asserts, “Ministers are commissioned and ordained in the church precisely to preach the Word of God. "), _c('a', {
    attrs: {
      "id": "page_2"
    }
  }, [_vm._v("They are given some fixed terms of reference — namely, the gospel of Jesus Christ — and they are committed to this sole and perennial message.”"), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/#fn2",
      "id": "fn-2"
    }
  }, [_vm._v("2")]), _vm._v(" The Lutheran homiletician M. Reu contends, “It is necessary that the sermon be Christocentric, have no one and nothing else for its centre and content than Christ Jesus.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn3",
      "id": "fn-3"
    }
  }, [_vm._v("3")])]), _vm._v(" The Reformed homiletician T. Hoekstra maintains, “In expositing Scripture for the congregation, the preacher … must show that there is a way to the center even from the farthest point on the periphery. For a sermon without Christ is no sermon.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn4",
      "id": "fn-4"
    }
  }, [_vm._v("4")])]), _vm._v(" And the Baptist preacher Charles Spurgeon says, “Preach Christ, always and everywhere. He is the whole gospel. His person, offices, and work must be our one great, all-comprehending theme.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn5",
      "id": "fn-5"
    }
  }, [_vm._v("5")])]), _vm._v(" Authors from a broad spectrum of traditions, therefore, testify to the necessity of preaching Christ."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn6",
      "id": "fn-6"
    }
  }, [_vm._v("6")])])]), _vm._v(" "), _c('h1', {
    staticClass: "sec2",
    attrs: {
      "id": "sec2-1"
    }
  }, [_c('strong', [_vm._v("Confusion about the Meaning of “Preaching Christ”")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Unfortunately, one could make a similar list of people complaining that the actual practice of preaching Christ falls far short of the ideal. One reason for this failure may be the difficulty of preaching Christ from the Old Testament. This problem is compounded by the lack of concrete directions in textbooks on Old Testament interpretation and preaching. Horror stories abound of preachers twisting an Old Testament text in order to land miraculously at Calvary. But subverting the Scriptures in order to preach Christ only undermines the authority of the message.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("To some, the notion of “preaching Christ” also seems rather narrow and confining, far removed from that other ideal of Christian preachers, namely, preaching “the whole counsel of God” (Acts 20:27). Does one "), _c('a', {
    attrs: {
      "id": "page_3"
    }
  }, [_vm._v("preach Christ, for example, at the expense of preaching other Christian doctrines, Christian living, or social justice concerns?")])]), _c('a', {
    attrs: {
      "id": "page_3"
    }
  }), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_3"
    }
  }, [_vm._v("But there are other reasons as well for the general failure to preach Christ. Strange as it may seem, we are not at all clear on what it means to “preach Christ.” Although the meaning seems simple on the surface, it is complicated by several factors, not the least of which is that Christ is both the eternal Logos, who is present from the beginning (John 1:1), and Christ incarnate, who is present only after Old Testament times (John 1:14). This complexity reveals itself in the wide variety of meanings that have attached themselves to the phrase “preaching Christ.”"), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/#fn7",
      "id": "fn-7"
    }
  }, [_vm._v("7")]), _vm._v(" For some, preaching Christ means preaching “Christ crucified” in the sense of linking every text to Calvary and Christ’s atoning work on the cross. Others broaden the meaning to preaching “Christ’s death and resurrection.” Still others seek to link the text to the work of the eternal Logos, who is active in Old Testament times especially as the Angel of Yahweh, the Commander of the Lord’s army, and the Wisdom of God. Others broaden the meaning even further to preaching sermons that center on God, for, it is argued, since Christ is the second person of the Trinity and fully God, a God-centered sermon is Christ-centered. Still others argue that “the Lord Jesus Christ is recognized as Jehovah,” and therefore we can substitute the name of Christ wherever we see “Jehovah” in the Old Testament."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn8",
      "id": "fn-8"
    }
  }, [_vm._v("8")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("At the beginning of this book on preaching Christ from the Old Testament, it would be well to come to clarity on what we mean by “preaching Christ.” But instead of adding another definition to a long list, we will find it far more valuable to examine the New Testament regarding the meaning of “preaching Christ.” After all, the apostles first coined the phrase.")]), _vm._v(" "), _c('h1', {
    staticClass: "sec2",
    attrs: {
      "id": "sec2-2"
    }
  }, [_c('strong', [_c('a', {
    attrs: {
      "id": "page_4"
    }
  }, [_vm._v("The New Testament on “Preaching Christ”")])])]), _c('a', {
    attrs: {
      "id": "page_4"
    }
  }, [_c('h1', {
    staticClass: "sec3",
    attrs: {
      "id": "sec3-1"
    }
  }, [_c('strong', [_c('em', [_vm._v("The Heart of Apostolic Preaching")])])])]), _c('p', {
    staticClass: "para"
  }, [_c('a', {
    attrs: {
      "id": "page_4"
    }
  }, [_vm._v("The heart of apostolic preaching is Jesus Christ. Richard Lischer notes, “A cursory review of the objects of the New Testament verbs for ‘preach’ shows how saturated with Christ that early proclamation was. Some of the objects are: Jesus, Lord Jesus, Christ, Jesus Christ as Lord, Christ crucified, Christ as raised from the dead, Jesus and the resurrection, good news about the Kingdom, Jesus as the Son of God, the gospel of God, Word of the Lord, the forgiveness of sins, and Christ in you — the hope of glory.”"), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/#fn9",
      "id": "fn-9"
    }
  }, [_vm._v("9")]), _vm._v(" As the objects of the verbs for preaching demonstrate, there can be no doubt that Christ is the heart of apostolic preaching. Yet this result does not resolve our predicament. Does “Christ” refer to Christ as the Second Person of the Trinity? Or to Christ as the eternal Logos? Or to Christ crucified? Or to the risen and exalted Lord? Or to all of the above? To find the answer, we will have to explore the New Testament further.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("In his book "), _c('em', [_vm._v("The Apostolic Preaching and Its Development,")]), _vm._v(" C. H. Dodd concludes that the first four speeches of Peter in Acts provide “a comprehensive view of the content of the early "), _c('em', [_vm._v("kerygma.")]), _vm._v("” He summarizes the contents of this preaching under six heads: First, “the age of fulfillment has dawned.” Second, “this has taken place through the ministry, death, and resurrection of Jesus, of which a brief account is given.” Third, “by virtue of the resurrection, Jesus has been exalted at the right hand of God, as Messianic head of the new Israel.” Fourth, “the Holy Spirit in the Church is the sign of Christ’s present power and glory.” Fifth, “the Messianic Age will shortly reach its consummation in the return of Christ.” And finally, “the "), _c('em', [_vm._v("kerygma")]), _vm._v(" always closes with an appeal for repentance, the offer of forgiveness and of the Holy Spirit, and the promise of ‘salvation.’”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn10",
      "id": "fn-10"
    }
  }, [_vm._v("10")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("A quick scrutiny of these six elements indicates that preaching in the New Testament church indeed centered on Jesus Christ — but not in the narrow sense of focussing only on Christ crucified, nor in the broadest sense of focussing only on the Second Person of the Trinity or the eternal Logos. The New Testament church preached the birth, ministry, death, resurrection, and exaltation of Jesus of Nazareth as the fulfillment of God’s old covenant promises, his presence today in the Spirit, and his imminent return. In short, “preaching Christ” meant preaching Christ incarnate in the context of the full sweep of redemptive history.")]), _vm._v(" "), _c('h1', {
    staticClass: "sec3",
    attrs: {
      "id": "sec3-2"
    }
  }, [_c('strong', [_c('em', [_c('a', {
    attrs: {
      "id": "page_5"
    }
  }, [_vm._v("The Breadth of Preaching Christ")])])])]), _c('a', {
    attrs: {
      "id": "page_5"
    }
  }, [_c('p', {
    staticClass: "para"
  }, [_vm._v("We can observe the tremendous breadth of the concept “preaching Christ” by following the apostles from preaching Christ crucified, to preaching Christ risen, to preaching the kingdom of God.")]), _vm._v(" "), _c('h1', {
    staticClass: "sec4",
    attrs: {
      "id": "sec4-1"
    }
  }, [_c('em', [_vm._v("Jesus’ Cross")])])]), _c('p', {
    staticClass: "para"
  }, [_c('a', {
    attrs: {
      "id": "page_5"
    }
  }, [_vm._v("Defenders of the narrow view that “preaching Christ” means only preaching the cross often appeal to the explicit statements of the apostle Paul. In 1 Corinthians 1:23 Paul reminds the church in Corinth, “We preach Christ crucified …” (NIV); and again in the next chapter, “I decided to know nothing among you except Jesus Christ, and him crucified” (1 Cor 2:2). However, Reu rightly cautions that the preacher should not “divorce the cross of Christ from His life, teaching and works, as preachers of the ‘old faith’ were accused of doing.”"), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/#fn11",
      "id": "fn-11"
    }
  }, [_vm._v("11")]), _vm._v(" For Paul, preaching “Christ crucified” has a much broader meaning than focussing every sermon on Jesus’ suffering on the cross. The cross of Christ is indeed the focal point for Paul’s preaching, but, as Paul’s sermons and letters demonstrate, the cross of Christ reveals much more than the suffering of Jesus. It also provides a viewpoint on the perfect justice of God (Rom 3:25-26) and the dreadful catastrophe of human sin. “The cross … signifies as nothing else could possibly do the awful seriousness of our sin, and therefore the depth and quality of the penitence that is required of us and that only the remembrance of it and the appropriation of its meaning can create in us.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn12",
      "id": "fn-12"
    }
  }, [_vm._v("12")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("But much more than the depth of sin and penitence is seen in the light of the cross. The cross of Christ also provides a view of the wondrous love of God for his creatures and creation (Rom 5:9-10; 8:32-34). “What the first Christians came to see was this — that God was there as nowhere else. This thing occurred, declared Peter in the first Christian sermon, …’ by the determinate counsel and foreknowledge of God.’ They never preached the Cross without saying, ‘This is God’s deed, God’s purpose in action, God’s way of bringing a mad and ruined world back to health and sanity and peace.’”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn13",
      "id": "fn-13"
    }
  }, [_vm._v("13")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("On a time line, the cross is but a point in the sweep of redemptive history from creation to the new creation. But exactly in the sweep of redemptive history, the cross is such a pivotal point that its impact echoes "), _c('a', {
    attrs: {
      "id": "page_6"
    }
  }, [_vm._v("all the way back to the fall of humanity and God’s penalty of "), _c('em', [_vm._v("death")]), _vm._v(" (Gen 3:19), even while it thrusts kingdom history forward to its full perfection — when all the nations will come in, there will be no more death and tears, and God will be all and in all (Rev 21:1-4). For, says Paul, “In Christ God was reconciling the world to himself, not counting their trespasses against them” (2 Cor 5:19).")])]), _c('a', {
    attrs: {
      "id": "page_6"
    }
  }, [_c('h1', {
    staticClass: "sec4",
    attrs: {
      "id": "sec4-2"
    }
  }, [_c('em', [_vm._v("Jesus’ Resurrection")])])]), _c('p', {
    staticClass: "para"
  }, [_c('a', {
    attrs: {
      "id": "page_6"
    }
  }, [_vm._v("In addition to bringing to view the vast vistas provided by the cross of Christ, Paul’s preaching focusses equally on the resurrection of Christ. Even the seemingly limited focus found in 1 Corinthians 2:2 of Paul knowing “nothing among you except Jesus Christ, and him crucified” may contain a much broader perspective. John Knox helpfully explains, “At first sight this last phrase [‘and him crucified’] seems to leave out the Resurrection entirely. But it seems to do so only because we suppose Paul’s thought was moving, as ours customarily does, in a forward direction …. But when Paul wrote the phrase, he was thinking first of all of the risen, exalted Christ, and his thought moved "), _c('em', [_vm._v("backward")]), _vm._v(" to the cross …. Thus, far from omitting reference to the Resurrection, Paul’s phrase takes its start from it; the word "), _c('em', [_vm._v("Christ")]), _vm._v(" means primarily the one now known as living and present Lord.”"), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/#fn14",
      "id": "fn-14"
    }
  }, [_vm._v("14")])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Other passages state more directly that Paul focusses equally on the resurrection of Christ. For example, when Paul and Barnabas preached in the synagogue of Antioch of Pisidia, Paul proclaimed, “God raised him from the dead …. And we bring you the good news that what God promised to our ancestors he has fulfilled for us, their children, by raising Jesus …” (Acts 13:30, 32; cf. Acts 17:31). Again, “Remember Jesus Christ, raised from the dead, a descendant of David — that is my gospel” (2 Tim 2:8). Consequently, James Stewart advises preachers, “I would urge you to preach the Resurrection as the one fact above all others which vitally concerns, not only the life of the individual Christian but the entire human scene and the destiny of the race. It is the break-through of the eternal order into this world of suffering and confusion and sin and death …. It is the vindication of eternal righteousness, the declaration that the heart of the universe is spiritual. It is the Kingdom of God made visible.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn15",
      "id": "fn-15"
    }
  }, [_vm._v("15")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_7"
    }
  }, [_vm._v("But we ought not to play the crucifixion and the resurrection off against each other. “The death and resurrection of Jesus are from the very beginning inseparably interconnected in the kerygma. They are the two aspects of "), _c('em', [_vm._v("one")]), _vm._v(" salvatory happening, continually calling each other to mind.”"), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/#fn16",
      "id": "fn-16"
    }
  }, [_vm._v("16")]), _vm._v(" In fact, in the very letter in which Paul states that he preaches “Christ crucified” (1 Cor 1:23; 2:2), he reminds the Corinthians “of the good news that I proclaimed to you …. For I handed on to you as of first importance what I in turn had received: that Christ died for our sins in accordance with the scriptures, and that he was buried, and that he was raised on the third day in accordance with the scriptures …” (1 Cor 15:1-4; cf. 15:12).")]), _vm._v(" "), _c('h1', {
    staticClass: "sec4",
    attrs: {
      "id": "sec4-3"
    }
  }, [_c('em', [_vm._v("The Kingdom of God")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Preaching the death and resurrection of Christ, we have seen, was more than recounting the facts concerning Jesus of Nazareth."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn17",
      "id": "fn-17"
    }
  }, [_vm._v("17")])]), _vm._v(" These two events provided remarkably profound insights into God’s justice, love, and final victory and into human sin, punishment, and salvation."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn18",
      "id": "fn-18"
    }
  }, [_vm._v("18")])]), _vm._v(" But they also provided viewpoints for perceiving the grand sweep of God’s plan of salvation as it unfolded in redemptive history."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn19",
      "id": "fn-19"
    }
  }, [_vm._v("19")])]), _vm._v(" The early Christian preachers proclaimed that “in these two shattering events, now seen to be one, the Kingdom of God had broken in with power …. What had formerly been pure eschatology was there before their eyes: the supernatural made visible, the Word made flesh. No longer were they dreaming of the Kingdom age: they were living in it. It had arrived.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn20",
      "id": "fn-20"
    }
  }, [_vm._v("20")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Accordingly, preaching Christ was intimately related to preaching the kingdom of God. Paul acknowledged that he also preached “Jesus Christ as Lord” (2 Cor 4:5), that is, as the Ruler who has received “all authority” (Matt 28:18). In Jesus Christ the kingdom of God had come. The "), _c('a', {
    attrs: {
      "id": "page_8"
    }
  }, [_vm._v("book of Acts ends with the stirring picture of Paul in custody in Rome — the kingdom of God has not yet arrived in perfection. But the great Apostle is in Rome, the center of the world, “proclaiming the kingdom of God and teaching about the Lord Jesus Christ” (Acts 28:31; cf. Acts 20:25).")])]), _c('a', {
    attrs: {
      "id": "page_8"
    }
  }, [_c('h1', {
    staticClass: "sec2",
    attrs: {
      "id": "sec2-3"
    }
  }, [_c('strong', [_vm._v("The Meaning of “Preaching Christ”")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("On the basis of this New Testament testimony, we can sketch the contours of what “preaching Christ” means. To clear the deck, it may be well to state first what it is not. Preaching Christ is not, of course, merely mentioning the name of Jesus or Christ in the sermon. It is not identifying Christ with Yahweh in the Old Testament, or the Angel of Yahweh, or the Commander of the Lord’s army, or the Wisdom of God. It is not simply pointing to Christ from a distance or “drawing lines to Christ” by way of typology.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Positively, preaching Christ is as broad as preaching the gospel of the kingdom of God. One has only to look at a concordance to see how often the New Testament speaks of “the gospel of the kingdom,” “the gospel of Christ,” “the gospel of Jesus Christ,” “the gospel of the grace of God,” and “the gospel of peace.” In these terms two characteristics stand out. Preaching Christ is good news for people, and preaching Christ is as broad as preaching the gospel of the kingdom — as long as this kingdom is related to its King, Jesus.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("More specifically, to preach Christ is to proclaim some facet of the "), _c('em', [_vm._v("person, work,")]), _vm._v(" or "), _c('em', [_vm._v("teaching")]), _vm._v(" of Jesus of Nazareth so that people may believe him, trust him, love him, and obey him. We shall take a closer look at each of these aspects.")]), _vm._v(" "), _c('h1', {
    staticClass: "sec3",
    attrs: {
      "id": "sec3-3"
    }
  }, [_c('strong', [_c('em', [_vm._v("The Person of Christ")])])])]), _c('p', {
    staticClass: "para"
  }, [_c('a', {
    attrs: {
      "id": "page_8"
    }
  }, [_vm._v("The distinction between the person and the work of Christ is fairly common (and controversial) in systematic theology"), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/#fn21",
      "id": "fn-21"
    }
  }, [_vm._v("21")]), _vm._v(" and in the literature about preaching Christ. The distinction should never lead to a separation between the person and the work of Christ, of course, for the two are inseparably intertwined."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn22",
      "id": "fn-22"
    }
  }, [_vm._v("22")])]), _vm._v(" Still, the distinction has merit in highlighting certain facets of the Messiah. Jesus himself asked his disciples, “Who do "), _c('a', {
    attrs: {
      "id": "page_9"
    }
  }, [_vm._v("you say that I am?” Peter’s answer, “You are the Messiah, the Son of the living God,” was a revelation from God himself, Jesus said (Matt 16:16-17). Knowing who Jesus was (Messiah, Son of God) helped the disciples understand somewhat the profound significance of his work of preaching and healing and dying and rising.")])]), _c('a', {
    attrs: {
      "id": "page_9"
    }
  }, [_c('p', {
    staticClass: "indent-para"
  }, [_vm._v("In fact, John "), _c('em', [_vm._v("begins")]), _vm._v(" his Gospel with the identity of the person of Christ. He writes, “No one has ever seen God. It is God the only Son, who is close to the Father’s heart, who has made him known” (John 1:18). The person of Jesus Christ, God’s only Son, is the climax of God’s revelation about himself. In Jesus we see God. He has made God known. Similarly, the letter to the Hebrews begins with the identity of the person of Christ: “He is the reflection of God’s glory and the exact imprint of God’s very being” (1:3).")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("In preaching Christ from the Old Testament, we can often link the Old Testament message to some facet of the person of Christ: the Son of God, the Messiah, our Prophet, Priest, and King.")]), _vm._v(" "), _c('h1', {
    staticClass: "sec3",
    attrs: {
      "id": "sec3-4"
    }
  }, [_c('strong', [_c('em', [_vm._v("The Work of Christ")])])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("In preaching Christ, we can also focus on a facet of the work of Christ. The Gospel writer John moves from the person of Jesus to some of the “signs” (works) he did, “so that you may come to believe that Jesus is the Messiah, the Son of God, and that through believing you may have life in his name” (John 20:31).")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Usually the work of Christ is associated with his work of reconciling us to God (atonement) through his suffering and death. But we can also think of his miracles of healing (signs of the presence of the kingdom), his resurrection (victory over death), his ascension (the enthronement of the King), and his coming again (the coming kingdom). In preaching Christ from the Old Testament, we can often link the message of the text with the redeeming work of our Savior and the just rule of our Lord.")]), _vm._v(" "), _c('h1', {
    staticClass: "sec3",
    attrs: {
      "id": "sec3-5"
    }
  }, [_c('strong', [_c('em', [_vm._v("The Teaching of Christ")])])])]), _c('p', {
    staticClass: "para"
  }, [_c('a', {
    attrs: {
      "id": "page_9"
    }
  }, [_vm._v("Although the teaching of Christ could be considered part of the work of Christ, Jesus’ teaching is often overlooked in discussions on preaching Christ from the Old Testament."), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/#fn23",
      "id": "fn-23"
    }
  }, [_vm._v("23")]), _vm._v(" Because of its significance for our topic, we shall consider the teaching of Christ separately.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_10"
    }
  }, [_vm._v("The importance of Jesus’ teaching rises to the surface with Jesus’ own statement, “If you hold to my teaching, you are really my disciples. Then you will know the truth, and the truth will set you free” (John 8:31-32, NIV). The crucial importance of the teaching of Christ shows up especially in Christ’s mandate to his disciples to “make disciples of all nations, baptizing them …, and teaching them to observe everything "), _c('em', [_vm._v("I have commanded you")]), _vm._v("” (Matt 28:19-20). The teaching of Jesus is an indispensable component for preaching Christ from the Old Testament, for the Old Testament was Jesus’ Bible, and he based his teaching on it. Jesus’ teaching includes not only teachings about himself (Son of Man, Messiah), his mission, and his coming again but also teachings about God, God’s kingdom, God’s covenant, God’s law (e.g., Matt 5–7), and the like.")])]), _c('a', {
    attrs: {
      "id": "page_10"
    }
  }, [_c('p', {
    staticClass: "para1"
  }, [_vm._v("Summing up this section, we can define “preaching Christ” as "), _c('em', [_vm._v("preaching sermons which authentically integrate the message of the text with the climax of God’s revelation in the person, work, and/or teaching of Jesus Christ as revealed in the New Testament")]), _vm._v(".")]), _vm._v(" "), _c('h1', {
    staticClass: "sec2",
    attrs: {
      "id": "sec2-4"
    }
  }, [_c('strong', [_vm._v("Reasons for Preaching Christ Today")])])]), _c('p', {
    staticClass: "para"
  }, [_c('a', {
    attrs: {
      "id": "page_10"
    }
  }, [_vm._v("In response to the question why we should preach Christ today, many might respond by pointing to the example of the apostles: If Peter and Paul preached Christ, then preachers today must preach Christ. But this argument from imitation is rather superficial and flawed. To imitate Paul in preaching Christ is rather selective imitation, for most of us do not imitate Paul in going on missionary journeys to do our preaching. Nor do we imitate Paul in going first to the synagogues to do our preaching. Nor do we imitate Paul in literally making tents to support a “tentmaking ministry.” In all these and other instances we realize that biblical "), _c('em', [_vm._v("de")]), _vm._v("scription of what Paul was doing does not necessarily translate into biblical "), _c('em', [_vm._v("pre")]), _vm._v("scription for us today."), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/#fn24",
      "id": "fn-24"
    }
  }, [_vm._v("24")]), _vm._v(" So we must dig deeper to make the case for preaching Christ today. We must ask ourselves: What were the underlying reasons for Paul and the other apostles to preach Christ? And do these reasons still hold for preachers today?")]), _vm._v(" "), _c('h1', {
    staticClass: "sec3",
    attrs: {
      "id": "sec3-6"
    }
  }, [_c('strong', [_c('em', [_c('a', {
    attrs: {
      "id": "page_11"
    }
  }, [_vm._v("Jesus’ Command: “Go … and Make Disciples of All Nations ….”")])])])]), _c('a', {
    attrs: {
      "id": "page_11"
    }
  }, [_c('p', {
    staticClass: "para"
  }, [_vm._v("A frequently overlooked but obvious reason why the apostles preached Christ was Jesus’ parting command: “Go … and make disciples of all nations, baptizing them in the name of the Father and of the Son and of the Holy Spirit, and teaching them to obey everything that I have commanded you. And remember, I am with you always, to the end of the age” (Matt 28:19-20). Although the baptismal formula is trinitarian, the command to make “disciples [of Jesus]” and to “teach … them to obey everything that I have commanded you,” and the promise of Jesus’ presence — all focus specifically on Jesus Christ. The apostle Peter later recalls, “He commanded us to preach to the people and to testify that he is the one ordained by God as judge of the living and the dead” (Acts 10:42).")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Even the apostle Paul, who did not receive the original mandate, would later receive the specific command to preach Christ. While he was on the way to Damascus to persecute Christians, the living Lord intercepted him: “I am Jesus, whom you are persecuting. But get up and enter the city, and you will be told what you are to do.” Then Jesus told Ananias to meet Paul, “for he is an instrument whom I have chosen to bring my name before the Gentiles and kings and before the people of Israel” (Acts 9:5-6, 15).")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The apostles, then, were commanded by their risen Lord to preach his “name” (the revelation concerning Jesus) among the nations, and they responded by preaching Jesus Christ. A few decades later, the Gospel writers accepted this original mandate as their mandate. For example, in writing his Gospel, Mark reveals his central concern in his opening verse: “The beginning of the good news of Jesus Christ, the Son of God.” Christian preachers today also live under the command to preach the “name” of Jesus Christ, for the command to preach Christ reaches far beyond the first apostles and Gospel writers — it reaches “to the end of the age.”")]), _vm._v(" "), _c('h1', {
    staticClass: "sec3",
    attrs: {
      "id": "sec3-7"
    }
  }, [_c('strong', [_c('em', [_vm._v("Exciting News: The King Has Come!")])])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("In addition to obedience to Jesus’ mandate, another major reason for preaching Christ lies in the message itself. Even today when a President or a Queen visits a city, the arrival itself is a newsworthy event. No one needs to command broadcasters to tell the story, for the story itself begs to be told. If this is true for the arrival of a President or a Queen, how much more for the arrival of “the King of Kings.” After centuries of waiting for God’s promised Messiah, after many high expectations and more dashed hopes, the story of his arrival simply has to be proclaimed.")])]), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_11"
    }
  }), _c('a', {
    attrs: {
      "id": "page_12"
    }
  }, [_vm._v("For example, when Peter’s brother Andrew met Jesus, he found a natural outlet for his excitement: “The first thing Andrew did was to find his brother Simon and tell him, ‘We have found the Messiah’ …. And he brought him to Jesus” (John 1:41-42, NIV). Andrew’s need to tell was but a small foretaste of the church’s missionary zeal after Jesus’ resurrection. This story simply has to be told: God has fulfilled his promises; his salvation has become a reality; the kingdom of God has broken into this world in a wonderful new way; the King has come!")])]), _c('a', {
    attrs: {
      "id": "page_12"
    }
  }, [_c('h1', {
    staticClass: "sec3",
    attrs: {
      "id": "sec3-8"
    }
  }, [_c('strong', [_c('em', [_vm._v("Life-Giving News: “Believe on the Lord Jesus, and You Will Be Saved.”")])])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Another major reason for preaching Christ lies in the life-saving character of the message. When there was an outbreak of polio in British Columbia, Canada, in the 1970s, the government wasted no time getting out the message to all parents to have their children inoculated against polio. It was a vital message; it needed to be broadcast immediately. The need to tell was obvious in the light of the disease and the availability of an antidote.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Ever since the fall into sin, humanity has been alienated from God and under the penalty of death. Everyone with discernment can recognize the disease, but not all know the cure. People need to be told about the cure. When the Philippian jailer cried out, “What must I do to be saved?” Paul answered, “Believe on the Lord Jesus, and you will be saved, you and your household” (Acts 16:30-31). As Paul put it a few years later, “If you confess with your lips that Jesus is Lord and believe in your heart that God raised him from the dead, you will be saved” (Rom 10:9). Faith in Jesus Christ is the antidote for eternal death. In a world dead in sin, alienated from God, headed for death, the life-giving message of Jesus Christ is so urgent that it simply must be told. For it is a message of hope, of reconciliation, of peace with God, of healing, of restoration, of salvation, of eternal life.")]), _vm._v(" "), _c('h1', {
    staticClass: "sec3",
    attrs: {
      "id": "sec3-9"
    }
  }, [_c('strong', [_c('em', [_vm._v("Exclusive News: “There Is Salvation in No One Else.”")])])])]), _c('p', {
    staticClass: "para"
  }, [_c('a', {
    attrs: {
      "id": "page_12"
    }
  }, [_vm._v("A further stimulus for preaching Christ is that Christ is the only way of salvation. As Peter puts it, “There is salvation in no one else, for there is no other name under heaven given among mortals by which we must be saved” (Acts 4:12). Peter’s hopeful but exclusive message echoes the message of Jesus himself, “I am the way, and the truth, and the life. No one comes to the Father except through me.”"), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/#fn25",
      "id": "fn-25"
    }
  }, [_vm._v("25")]), _vm._v(" Eternal life is to be found only in Jesus Christ.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_13"
    }
  }, [_vm._v("If Jesus were one of many ways of salvation, the church could relax a bit, hoping that people might find some other way to be saved from death. But now that Christ is the only way, the urgency of preaching Christ is all the more pressing. There is salvation in no one else but Jesus."), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/#fn26",
      "id": "fn-26"
    }
  }, [_vm._v("26")])]), _vm._v(" "), _c('p', {
    staticClass: "para1"
  }, [_vm._v("All of the above reasons for preaching Christ hold today as much as they did in the times of the New Testament church, for Jesus’ command is valid “till the end of the age.” In a century which counts more Christian martyrs than in all of church history, the good news that the King has come is as significant and encouraging as ever; in a materialistic age in which people despair of the meaning of human life, the vital news that there is salvation from death through faith in Christ is as crucial as ever; and in our relativistic, pluralistic society with its many so-called saviors, the exclusive news that there is salvation in no one else but Jesus Christ is as essential as ever.")]), _vm._v(" "), _c('h1', {
    staticClass: "sec3",
    attrs: {
      "id": "sec3-10"
    }
  }, [_c('strong', [_c('em', [_vm._v("Hearers in a Non-Christian Culture")])])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("The final reason for preaching Christ is that our hearers are living in a non-Christian culture. The early church, in the nature of the case, addressed people living in a non-Christian culture. People needed to hear about Christ and the difference he makes. But contemporary preachers equally address people living in a non-Christian or post-Christian culture. If contemporary hearers were living in a culture saturated with Christian thinking and action, one might perhaps take for granted that people hearing a sermon would sense how it is related to Christ. For all of life is related to Christ. As Paul writes, “He [Christ] is the image of the invisible God …; for in him all things in heaven and on earth were created …— all things have been created through him and for him. He himself is before all things, and in him all things hold together” (Col 1:15-17). But preachers today cannot assume that their hearers will see these connections; they cannot even assume that their hearers will know the meaning of words like “gospel” and “God” and “Christ.”")]), _vm._v(" "), _c('h1', {
    staticClass: "sec4",
    attrs: {
      "id": "sec4-4"
    }
  }, [_c('em', [_vm._v("Non-Christian Hearers")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Europe and North America have become mission fields. People have lost their way and are searching for the Ultimate, for meaning to their brief existence on earth. Church services are fast moving from Christian "), _c('a', {
    attrs: {
      "id": "page_14"
    }
  }, [_vm._v("worship to “seeker services.” Today, both in Christian worship (seeker sensitive, one would hope) and in seeker services, Christ needs to be preached. “One of the most fascinating of all the preacher’s tasks,” John Stott writes, “is to explore both the emptiness of fallen man and the fullness of Jesus Christ, in order then to demonstrate how he can fill our emptiness, lighten our darkness, enrich our poverty, and bring our human aspirations to fulfillment.”"), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/#fn27",
      "id": "fn-27"
    }
  }, [_vm._v("27")]), _vm._v(" For “to encounter Christ is to touch reality and experience transcendence. He gives us a sense of self-worth or personal significance, because he assures us of God’s love for us. He sets us free from guilt because he died for us, from the prison of our own self-centredness by the power of his resurrection, and from paralyzing fear because he reigns …. He gives meaning to marriage and home, work and leisure, personhood and citizenship.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn28",
      "id": "fn-28"
    }
  }, [_vm._v("28")])])]), _vm._v(" "), _c('h1', {
    staticClass: "sec4",
    attrs: {
      "id": "sec4-5"
    }
  }, [_c('em', [_vm._v("Christian Hearers")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Committed Christians as well as non-Christians will benefit from explicitly Christ-centered preaching today. In a post-Christian culture such preaching will enable Christians to sense the centrality of Christ in their lives and in the world. It will help them to distinguish their specific faith from that of Judaism, Eastern religions, the new age movement, the health-and-wealth gospel, and other competing faiths. It will continually build their faith in Jesus, their Savior and Lord. Preaching Christ in a non-Christian culture sustains Christians as water sustains nomads in the desert. Reu claims, “Genuine Christian faith and life can exist only so long as it remains a daily appropriation of Christ.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn29",
      "id": "fn-29"
    }
  }, [_vm._v("29")])]), _vm._v(" Even those committed to Christ must continually learn and relearn what it means to serve Jesus their Savior as Lord of their life.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Preaching in a post-Christian culture places a tremendous responsibility on contemporary preachers to preach Christ plainly, genuinely, and perceptively. Preachers can no longer assume that their hearers will discern the connections of the message with Christ in the context of a Christian mind-set and in the context of Christian worship. These connections need to be intentionally exposed for all to see. John Stott brings the goal into focus for contemporary preachers: “The main objective of preaching is to expound Scripture so faithfully and relevantly that Jesus Christ is perceived in all his adequacy to meet human need.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn30",
      "id": "fn-30"
    }
  }, [_vm._v("30")])]), _vm._v(" William Hull adds "), _c('a', {
    attrs: {
      "id": "page_15"
    }
  }, [_vm._v("this sound advice, “Let us not mount the pulpit to debate peripheral questions or to speculate on esoteric curiosities …. We are there to preach Jesus Christ as Lord …. That is our awesome assignment: to put into words, in such a way that our hearers will put into deeds, the new day that is ours in Jesus Christ our Lord.”"), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/#fn31",
      "id": "fn-31"
    }
  }, [_vm._v("31")])]), _vm._v(" "), _c('h1', {
    staticClass: "sec1",
    attrs: {
      "id": "sec-2"
    }
  }, [_c('strong', [_vm._v("THE NECESSITY OF PREACHING FROM THE OLD TESTAMENT")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Before we focus our discussion of preaching Christ specifically on preaching Christ from the Old Testament ("), _c('span', {
    attrs: {
      "href": "#/009_Chapter02#ch-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 2")]), _vm._v("), we must first consider the general question of preaching from the "), _c('em', [_vm._v("Old")]), _vm._v(" Testament. It is no secret that the Old Testament is like a lost treasure in the church today. Comments like “the Old Testament was a closed book in my experience”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn32",
      "id": "fn-32"
    }
  }, [_vm._v("32")])]), _vm._v(" are indicative of a trend. W. A. Criswell claims that the Old Testament is “perhaps the most neglected area of the Bible in modern preaching,” and that, when the Old Testament is used, “it is often only the text for some topical treatise that soon departs from its context.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn33",
      "id": "fn-33"
    }
  }, [_vm._v("33")])]), _vm._v(" Gleason Archer muses, “Curious to observe and hard to understand is the relative neglect of the Old Testament by Christians in our day as Sunday after Sunday the average church attendant in the average evangelical, Bible-believing church hears no message at all from the Hebrew Scriptures.” And he asks, “How can Christian pastors hope to feed their flock on a well-balanced spiritual diet if they completely neglect the 39 books of Holy Scripture on which Christ and all the New Testament authors received their own spiritual nourishment?”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn34",
      "id": "fn-34"
    }
  }, [_vm._v("34")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Statistics are hard to come by, but from reports of several denominations it is safe to conclude that fewer than 20 percent of the sermons the average church member hears are based on an Old Testament text."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn35",
      "id": "fn-35"
    }
  }, [_vm._v("35")])]), _vm._v(" This figure is all the more telling when we remember that the Old Testament constitutes about three-fourths of the Christian canon. The editor of an "), _c('a', {
    attrs: {
      "id": "page_16"
    }
  }, [_vm._v("evangelical journal for preachers laments, “I annually receive hundreds of sermon manuscripts from ministers in a variety of Protestant denominations …. Less than one-tenth of the sermons submitted to "), _c('em', [_vm._v("Preaching")]), _vm._v(" are based on Old Testament texts.”"), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/#fn36",
      "id": "fn-36"
    }
  }, [_vm._v("36")])]), _vm._v(" "), _c('h1', {
    staticClass: "sec2",
    attrs: {
      "id": "sec2-5"
    }
  }, [_c('strong', [_vm._v("Reasons for the Lack of Preaching from the Old Testament")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("There may be many individual reasons for the lack of preaching from the Old Testament. We shall discuss four of the major ones: the use of lectionaries, critical Old Testament scholarship, the rejection of the Old Testament, and the difficulties of preaching from the Old Testament.")]), _vm._v(" "), _c('h1', {
    staticClass: "sec3",
    attrs: {
      "id": "sec3-11"
    }
  }, [_c('strong', [_c('em', [_vm._v("The Use of Lectionaries")])])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("The use of lectionaries has had both a positive and a negative impact on preaching from the Old Testament. Positively, by including Old Testament readings, lectionaries have certainly contributed to the Old Testament being heard again in Christian worship services. Foster McCurley acknowledges, “In my own Lutheran tradition it was not until … 1958 … that an Old Testament lesson was prescribed for weekly reading at the Service. Until this date in most American Lutheran churches only an Epistle and a Gospel had been read ….”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn37",
      "id": "fn-37"
    }
  }, [_vm._v("37")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Reading an “Old Testament lesson,” however, does not necessarily translate into preaching it, for most pastors will select their preaching-text from the New Testament readings. This preference for a New Testament text is dictated partly by the predilections of pastors, but it is also built into most lectionaries. In following the church year (the life of Christ) from Advent to Christmas to Epiphany to Lent to Easter to Pentecost, the continuous readings tend to come from one of the Gospels. Consequently, the Old Testament readings provide at most a supportive role. What is more, “the Old Testament readings … have little if any continuity from Sunday to Sunday.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn38",
      "id": "fn-38"
    }
  }, [_vm._v("38")])]), _vm._v(" Thus by following the church year and providing continuity in the Gospel readings, lectionaries tilt the selection of preaching-texts in favor of the New Testament.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_17"
    }
  }, [_vm._v("Dennis Olson raises another concern. He observes that “most lectionaries use readings from a quite limited body of Old Testament material” — mainly Isaiah, Jeremiah, Genesis, Exodus, and Deuteronomy. “Citations from other Old Testament books rapidly fall off …. In the present shape of most lectionaries, eighty percent of the Old Testament witness is never even read in congregational worship, much less preached. It is like taking the Boston Symphony Orchestra and stripping it of all but twenty percent of its players …. What happens when we strip down the Old Testament to twenty percent of its full voice? What theological emphases are lost?”"), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/#fn39",
      "id": "fn-39"
    }
  }, [_vm._v("39")])]), _vm._v(" "), _c('h1', {
    staticClass: "sec3",
    attrs: {
      "id": "sec3-12"
    }
  }, [_c('strong', [_c('em', [_vm._v("Critical Old Testament Scholarship")])])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("A more serious reason for the lack of preaching from the Old Testament is the kind of training in Old Testament many preachers receive in various theological seminaries and universities. “By the beginning of the twentieth century, theological exegesis as the paramount concern of biblical scholarship had been supplanted by the scientific-historical conception of the scholar’s task.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn40",
      "id": "fn-40"
    }
  }, [_vm._v("40")])]), _vm._v(" Higher criticism concentrated on source criticism, form criticism, and history of religion. The Old Testament was studied only to recover the history of Israel, the history of its literature, and the history of its religion — and future preachers were left without a word from God to preach. Illustrative of the sterility of theological training was the resignation of Julius Wellhausen (of source-criticism fame) as professor of theology at Greifswald University and his acceptance of the position of professor of Semitic languages at Halle. He explained the reason for his switch from theology to Semitic languages as follows: “I became a theologian because I was interested in the scientific treatment of the Bible; it has only gradually dawned upon me that a professor of theology likewise has the practical task of preparing students for service in the Evangelical Church, and that I was not fulfilling this practical task, but rather, in spite of all reserve on my part, was "), _c('em', [_vm._v("incapacitating")]), _vm._v(" my hearers for their office.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn41",
      "id": "fn-41"
    }
  }, [_vm._v("41")])]), _vm._v(" Some fifty years later, training for preaching from the Old Testament had not improved, at least not in Germany. Von Rad observes that “Old Testament scholarship … with an almost religious earnestness, … had trained people to the ethic of an incorruptible historical "), _c('a', {
    attrs: {
      "id": "page_18"
    }
  }, [_vm._v("discernment; but it had not trained them to acknowledge the Old Testament publicly …— what theologians call "), _c('em', [_vm._v("in statu confessionis.")]), _vm._v("”"), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/#fn42",
      "id": "fn-42"
    }
  }, [_vm._v("42")]), _vm._v(" The recent rise of redaction criticism, rhetorical criticism, narrative criticism, and the canonical approach holds greater promise of biblical scholars focussing their energy on understanding the message of Old Testament literature for Israel and thus helping prepare students for their task of preaching from the Old Testament."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn43",
      "id": "fn-43"
    }
  }, [_vm._v("43")])])]), _vm._v(" "), _c('h1', {
    staticClass: "sec3",
    attrs: {
      "id": "sec3-13"
    }
  }, [_c('strong', [_c('em', [_vm._v("Rejection of the Old Testament")])])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Still another reason for the lack of preaching from the Old Testament is the outright rejection of the Old Testament. Rejection of the Old Testament has a long history, going back all the way to Marcion. To get an idea of the reasons why people reject the Old Testament, we shall briefly review the positions of four theologians: Marcion, Schleiermacher, von Harnack, and Bultmann.")]), _vm._v(" "), _c('h1', {
    staticClass: "sec4",
    attrs: {
      "id": "sec4-6"
    }
  }, [_c('em', [_vm._v("Marcion (ca. 85-160)")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Marcion was a wealthy shipowner on the southern shore of the Black Sea. Around the year "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("A.D.")]), _vm._v(" 140 he moved to Rome, where he became a member of the church. “While in Rome, he succumbed to the influence of the unorthodox Syrian teacher Cerdo, from whom he derived the basis of his teaching, the differentiation between the God portrayed in the Old Testament and the God portrayed in the New.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn44",
      "id": "fn-44"
    }
  }, [_vm._v("44")])]), _vm._v(" When Marcion was excommunicated in 144, he founded his own church and spread his peculiar views far and wide.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Like the Gnostics,"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn45",
      "id": "fn-45"
    }
  }, [_vm._v("45")])]), _vm._v(" Marcion held to a dualistic view of the universe: the material world is evil and the spiritual world is good. A good God (pure Spirit) could not possibly have created this material world. Since the God of the Old Testament is the Creator God, he must be an inferior deity, a demiurge. We also meet him in the Old Testament as the God of the law, a God of wrath, a God of war, a stern judge. The God revealed in the New Testament, by contrast, is a God of love, grace, and peace. The true God sent Jesus Christ to rescue us from this evil world. Because he started with a "), _c('a', {
    attrs: {
      "id": "page_19"
    }
  }, [_vm._v("different God in each of the Testaments and because he saw seeming contradictions between the Testaments, Marcion rejected the Old Testament and tried to purge the New Testament of all references to the Old Testament. Marcion’s wholesale rejection of the Old Testament forced the Christian church to reflect on its canon. The church concluded that the Old Testament belonged to its canon as much as the New — the two were one."), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/#fn46",
      "id": "fn-46"
    }
  }, [_vm._v("46")])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The church’s official declaration in "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("A.D.")]), _vm._v(" 382"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn47",
      "id": "fn-47"
    }
  }, [_vm._v("47")])]), _vm._v(" that the books of the Hebrew Old Testament also belonged to its canon should have settled the matter. Regrettably, this was not the end of the story. It is hard for independent thinkers to submit to the biblical canon (the rule, standard), to bring every thought captive to the Scriptures. Or, to put it another way, it is extremely difficult to enter the hermeneutical circle for interpreting the Old Testament with genuine biblical presuppositions. It is all too easy to start with nonbiblical presuppositions and make them the rule (canon) by which we judge the Scriptures. Marcion’s nonbiblical starting point was two Gods — and the Bible was torn apart. Instead of respectful submission to the Scriptures as the word of God, Marcion ruled over the Scriptures.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Others have followed in Marcion’s footsteps. Scholars need not, like Marcion, start out with two Gods. They only have to subscribe to a new definition of revelation or a new view of religion or a new norm of ethics — and instead of submitting to the canon, they rule over the canon and begin to cut out certain parts as inferior and unworthy. Throughout church history Marcionism, in the sense of rejecting or ignoring the Old Testament, kept resurfacing. We need not review the whole story;"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn48",
      "id": "fn-48"
    }
  }, [_vm._v("48")])]), _vm._v(" a few quotations from recent influential scholars will be sufficient to make the point.")]), _vm._v(" "), _c('h1', {
    staticClass: "sec4",
    attrs: {
      "id": "sec4-7"
    }
  }, [_c('em', [_c('a', {
    attrs: {
      "id": "page_20"
    }
  }, [_vm._v("Friedrich Schleiermacher (1768-1834)")])])]), _c('a', {
    attrs: {
      "id": "page_20"
    }
  }), _c('p', {
    staticClass: "para"
  }, [_c('a', {
    attrs: {
      "id": "page_20"
    }
  }, [_vm._v("Schleiermacher is famous for his new definition of religion as the “feeling of absolute dependence on God.” He further “defines revelation as something new in the sphere of religious feelings that is basic for a certain religious community’s life ….”"), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/#fn49",
      "id": "fn-49"
    }
  }, [_vm._v("49")]), _vm._v(" With this subjectivistic spin on revelation, the Old Testament comes to be regarded not just as pre-Christian but as sub-Christian. Schleiermacher sees no continuity between Judaism and Christianity; instead he argues that “the relations of Christianity to Judaism and Heathenism are the same, inasmuch as the transition from either of these to Christianity is a transition to another religion.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn50",
      "id": "fn-50"
    }
  }, [_vm._v("50")])]), _vm._v(" He also suggests that it might be better “if the Old Testament were put after the New as an appendix ….”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn51",
      "id": "fn-51"
    }
  }, [_vm._v("51")])]), _vm._v(" Kraeling, an admirer, writes, “The greatest theologian of nineteenth-century Protestantism was thus in favour of putting the Old Testament in an extremely subordinate position. But he hesitates to draw the full consequences of his standpoint by joining the Marcionite group.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn52",
      "id": "fn-52"
    }
  }, [_vm._v("52")])])]), _vm._v(" "), _c('h1', {
    staticClass: "sec4",
    attrs: {
      "id": "sec4-8"
    }
  }, [_c('em', [_vm._v("Adolf von Harnack (1851-1930)")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Harnack was an influential exponent of Liberal Protestantism. He wrote the classic work on Marcion. “He concedes that Marcion went too far in considering the Creator God and the Christian God two entirely different gods …. But that, he argues, cannot save the Old Testament.” He asks Christians to “consider the harm the Old Testament does to their cause. Much of the opposition to Christianity in the modern world is based on the Old Testament, which affords so much opportunity to people to attack and ridicule the Bible ….”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn53",
      "id": "fn-53"
    }
  }, [_vm._v("53")])]), _vm._v(" Harnack suggests that the Old Testament should be included with the Apocrypha, “the books which are useful to read but not authoritative.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn54",
      "id": "fn-54"
    }
  }, [_vm._v("54")])]), _vm._v(" This is his considered opinion: “To have cast aside the Old Testament in the second century was an error which the church rightly rejected; to have retained it in the sixteenth century was a fate which the Reformation was not yet able to avoid; but still to keep it after the nineteenth century as a canonical "), _c('a', {
    attrs: {
      "id": "page_21"
    }
  }, [_vm._v("document within Protestantism results from a religious and ecclesiastical paralysis.”"), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/#fn55",
      "id": "fn-55"
    }
  }, [_vm._v("55")])]), _vm._v(" "), _c('h1', {
    staticClass: "sec4",
    attrs: {
      "id": "sec4-9"
    }
  }, [_c('em', [_vm._v("Rudolf Bultmann (1884-1976)")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("We could consider many other persons,"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn56",
      "id": "fn-56"
    }
  }, [_vm._v("56")])]), _vm._v(" but we shall move straight to the influential Rudolf Bultmann. Scholars have debated whether Bultmann should be classified as a Marcionite, for he does not reject the Old Testament outright."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn57",
      "id": "fn-57"
    }
  }, [_vm._v("57")])]), _vm._v(" But it cannot be denied that he accepts its value for the church in a very restricted and negative sense. In “The Significance of the Old Testament for the Christian Faith,” he acknowledges that “the New Testament presupposes the Old, the Gospel presupposes the Law.” But then he goes right on to say, “It can be only for pedagogical reasons that the Christian Church uses the Old Testament to make man conscious of standing under God’s demand.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn58",
      "id": "fn-58"
    }
  }, [_vm._v("58")])]), _vm._v(" That is the “positive” side.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("But these minimal, qualified statements regarding the significance of the Old Testament for the Christian must be weighed against Bultmann’s perturbing negative statements in the same article: “To the Christian faith the Old Testament is no longer revelation as it has been, and still is, for the Jews. For the person who stands within the Church the history of Israel is a closed chapter …. Israel’s history is not our history, and in so far as God has shown his grace in that history, such grace is not meant for us …. To us the history of Israel is not history of revelation. The events which meant something for Israel, which were God’s Word, mean nothing more to us …. To the Christian faith the Old Testament is not in the true sense God’s Word.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn59",
      "id": "fn-59"
    }
  }, [_vm._v("59")])])]), _vm._v(" "), _c('p', {
    staticClass: "para1"
  }, [_vm._v("The Old Testament is still maligned and slighted. Today Marcionism may not be promoted as blatantly as it was by the theologians who just passed "), _c('a', {
    attrs: {
      "id": "page_22"
    }
  }, [_vm._v("our review, but ideas have wings, and even in distant places these pernicious ideas have tainted the image of the Old Testament."), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/#fn60",
      "id": "fn-60"
    }
  }, [_vm._v("60")]), _vm._v(" Moreover, today Marcionism is fostered by default by preachers who bypass or pay only lip-service to the Old Testament. It is also fostered by preachers who use the Old Testament only “as a foil for heightening the uniqueness of the teachings of Jesus.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn61",
      "id": "fn-61"
    }
  }, [_vm._v("61")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Sadly, even today the question is being raised whether the God of the Old Testament is the God of the New Testament. It is a question that has troubled the church for centuries and muddied the waters of theological debate. But it is a foolhardy question, for it does not arise from the Scriptures themselves. Every morning and evening the Israelites were reminded: “Hear, O Israel: The L"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ORD")]), _vm._v(" our God, the L"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ORD")]), _vm._v(" is one” (Deut 6:4, NIV). Jesus, the true Israelite, revealed this one Lord and called him Father. We may raise questions about different emphases in and tensions between the two Testaments, but to contemplate the question of different Gods is to take one’s starting point outside the canon in an alien religion.")]), _vm._v(" "), _c('h1', {
    staticClass: "sec3",
    attrs: {
      "id": "sec3-14"
    }
  }, [_c('strong', [_c('em', [_vm._v("Difficulties in Preaching from the Old Testament")])])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Beginning with the biblical presuppositions of one God and one Bible does not alleviate all the difficulties of preaching from the Old Testament, of course, but it does allow us to address them within the context of the historic Christian faith. For there is no doubt that another major reason for slighting the Old Testament is the genuine difficulty the preacher faces in preaching from the Old Testament. We can distinguish at least four sets of difficulties: historical-cultural, theological, ethical, and practical.")]), _vm._v(" "), _c('h1', {
    staticClass: "sec4",
    attrs: {
      "id": "sec4-10"
    }
  }, [_c('em', [_vm._v("Historical-Cultural Difficulties")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("The Old Testament is an ancient book set in a Middle Eastern, agricultural society. We enter a foreign world of temples and animal sacrifices, of sabbatical years and dietary laws. This world is far removed from the modern church in a Western, postindustrial, urban setting. Preaching from the Old Testament, the preacher comes face-to-face with the "), _c('a', {
    attrs: {
      "id": "page_23"
    }
  }, [_vm._v("historical-cultural gap. It seems impossible to preach relevant sermons from this ancient book.")])]), _c('a', {
    attrs: {
      "id": "page_23"
    }
  }), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_23"
    }
  }, [_vm._v("The immense historical-cultural gap appears to be the main reason for the lack of preaching from the Old Testament today. Donald Gowan in his book "), _c('em', [_vm._v("Reclaiming the Old Testament for the Christian Pulpit")]), _vm._v(" claims that “the central problem which has faced modern preachers who attempt to use the Old Testament faithfully is "), _c('em', [_vm._v("discontinuity.")]), _vm._v("”"), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/#fn62",
      "id": "fn-62"
    }
  }, [_vm._v("62")]), _vm._v(" The Old Testament seems to have little to say to Christians living in an entirely different era from that of Israel. Approaching this issue from a different angle, Walter Kaiser comes to the same conclusion: “Overriding all of the reasons for neglect of the Old Testament … is the issue of the Bible’s historical particularity; that is, its words are most frequently, if not always in the Old Testament, directed to a "), _c('em', [_vm._v("specific")]), _vm._v(" people in a "), _c('em', [_vm._v("specific")]), _vm._v(" situation at a "), _c('em', [_vm._v("specific")]), _vm._v(" time and in a "), _c('em', [_vm._v("specific")]), _vm._v(" culture. That is the real difficulty.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn63",
      "id": "fn-63"
    }
  }, [_vm._v("63")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Granted that it presents a major problem for preaching relevantly from the Old Testament today, the historical-cultural gap need not be viewed entirely negatively. For the fact that we, from our times, discern a historical-cultural gap discloses the fact that the Old Testament addressed its own time relevantly: God’s word did not float high above Israel as an eternal word but entered Israel’s culture in a relevant way. Instead of an obstacle, therefore, the historical-cultural gap can become a challenge for preachers to discern this past relevance and to preach the message of the Old Testament just as relevantly today as it addressed Israel in the past."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn64",
      "id": "fn-64"
    }
  }, [_vm._v("64")])])]), _vm._v(" "), _c('h1', {
    staticClass: "sec4",
    attrs: {
      "id": "sec4-11"
    }
  }, [_c('em', [_vm._v("Theological Difficulties")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("More than eighteen hundred years ago Marcion confronted the church with some major theological difficulties in preaching from the Old Testament. For example, he noted differences between the God revealed in the Old Testament and in the New Testament: in the Old Testament God commanded Israel to “exterminate” the Canaanites without mercy (Josh 11:20), “but Christ forbade all force and preached mercy and peace”; “the Creator sends down fire at the demand of Elijah (2 Kings 1:9-12), but Christ forbids the disciples to ask for fire from heaven”; “The Old Testament God is mighty in war; Christ brings peace.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn65",
      "id": "fn-65"
    }
  }, [_vm._v("65")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_24"
    }
  }, [_vm._v("One does not have to begin with two different Gods to notice that there are differences between the Old Testament revelation of God and that of the New Testament. The Old Testament at times presents God as a stern, judging God, “punishing children for the iniquity of parents to the third and the fourth generation of those who reject me” (Exod 20:5), while the New Testament presents God as the one who “so loved the world that he gave his only Son” (John 3:16) and who is quick to forgive (1 John 1:9). The Old Testament presents God’s blessings in the area of material wealth (many children, livestock, harvests — Deut 30:9), while the New Testament sees God’s greatest blessing as “eternal life” (John 3:16). The Old Testament seems to present salvation by works (e.g., “If you obey the commandments …, then you shall live …”; Deut 30:16), while the New Testament presents salvation by faith (Rom 5:1). In preaching from the Old Testament, preachers need to resolve these and many other tensions. In ")]), _c('span', {
    attrs: {
      "href": "#/010_Chapter03#ch-3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapters 3")]), _vm._v(" and "), _c('span', {
    attrs: {
      "href": "#/011_Chapter04#ch-4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4")]), _vm._v(" we shall see how the church sought to address these issues with the idea of progressive revelation.")]), _vm._v(" "), _c('h1', {
    staticClass: "sec4",
    attrs: {
      "id": "sec4-12"
    }
  }, [_c('em', [_vm._v("Ethical Difficulties")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("In addition to the historical-cultural and theological problems, preachers will be confronted with ethical difficulties. Eighteen hundred years ago already Marcion tripped over some of these ethical obstacles: “In the Law it says: ‘An eye for an eye, a tooth for a tooth.’ The Lord, however, the good, says in the Gospel: ‘If any strike thee on one cheek, offer him the other also.’ In the Law God (the Creator) says: ‘Thou shalt love him who loveth thee, and hate thine enemy.’ But our Lord, the good, says: ‘Love your enemies, and pray for those who persecute you.’”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn66",
      "id": "fn-66"
    }
  }, [_vm._v("66")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("These particular problems have been highlighted throughout church history by detractors of the Old Testament. But preachers will be confronted by many other ethical difficulties as well. For example, the law of Moses demanded the execution not only of murderers but also of witches (Exod 22:18), idolaters (Deut 13:6-10; 16:2-7), and even of a “stubborn and rebellious son” (Deut 21:18-21). And some of the Psalms beg God to annihilate the enemy and more: “Happy shall they be who take your little ones and dash them against the rock!” (Ps 137:9; cf. Ps 109:6-13)."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn67",
      "id": "fn-67"
    }
  }, [_vm._v("67")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Sensitive Christians can easily be offended by certain parts of the "), _c('a', {
    attrs: {
      "id": "page_25"
    }
  }, [_vm._v("Old Testament. In this connection John Bright raises the interesting question as to why, “although the Old Testament on occasion offends our Christian feelings, it did not apparently offend Christ’s ‘Christian feelings’! Could it really be that we are ethically and religiously more sensitive than he? Or is it perhaps that we do not view the Old Testament — and its God — as he did?”"), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/#fn68",
      "id": "fn-68"
    }
  }, [_vm._v("68")])]), _vm._v(" "), _c('h1', {
    staticClass: "sec4",
    attrs: {
      "id": "sec4-13"
    }
  }, [_c('em', [_vm._v("Practical Difficulties")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("In addition to the historical-cultural, theological, and ethical difficulties, there are also some obvious practical difficulties in preaching from the Old Testament. Foster McCurley describes the challenges: “The Old Testament is so broad; it requires a staggering breadth of knowledge of history, literature, and theology …. Rather than covering one century as does the New Testament, the Old Testament spans twelve centuries of literature and approximately eighteen of history …. The breadth of Old Testament study … itself is frightening and demanding for the interpreter.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn69",
      "id": "fn-69"
    }
  }, [_vm._v("69")])])]), _vm._v(" "), _c('h1', {
    staticClass: "sec2",
    attrs: {
      "id": "sec2-6"
    }
  }, [_c('strong', [_vm._v("Reasons for Preaching from the Old Testament as well as the New")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("In spite of these major hurdles, there are many reasons why pastors must preach from the Old Testament: (1) the Old Testament is part of the Christian canon, (2) it discloses the history of redemption leading to Christ, (3) it proclaims truths not found in the New Testament, (4) it helps us understand the New Testament, (5) it prevents misunderstanding the New Testament, and (6) it provides a fuller understanding of Christ. In concluding this chapter, we shall discuss the first five reasons.")]), _vm._v(" "), _c('h1', {
    staticClass: "sec3",
    attrs: {
      "id": "sec3-15"
    }
  }, [_c('strong', [_c('em', [_vm._v("The Old Testament Is Part of the Christian Canon")])])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("The first reason for preaching from the Old Testament is that the church has accepted this collection of books as part of its canon. To accept a document as part of one’s canon only to let this “standard for faith and life” gather dust makes little sense. If the Old Testament is part of the Christian canon, then it should be used in the church. Paul instructs Timothy to “give attention to the public reading of scripture [that is, the Old "), _c('a', {
    attrs: {
      "id": "page_26"
    }
  }, [_vm._v("Testament], to exhorting, to teaching” (1 Tim 4:13). Later Paul makes the argument that the Old Testament is inspired (“God-breathed”) to be used. He writes, “All scripture is inspired by God and useful for teaching, for reproof, for correction, and for training in righteousness, so that everyone who belongs to God may be proficient, equipped for every good work” (2 Tim 3:16-17). The Old Testament, says Paul, is useful for teaching Christians. It contains teachings which the New Testament simply assumes but does not necessarily repeat (see examples below). In fact, in the preceding verse (15), Paul claims that “the sacred writings … are able to instruct you [literally, “make you wise”] for salvation through faith in Christ Jesus.” The Old Testament is also useful for “reproof,” that is, for showing sinners the error of their ways so that they may return to holy living (think of the moral law and of wisdom literature). It is also useful for “correction,” that is, “setting straight that which had become bent or twisted.” Finally, says Paul, it is useful for “training in righteousness,” that is, instruction that will lead to a state of being upright."), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/#fn70",
      "id": "fn-70"
    }
  }, [_vm._v("70")]), _vm._v(" In Romans 15:4 Paul adds the element of hope we can receive from the Old Testament: “Whatever was written in former days was written for our instruction, so that by steadfastness and by the encouragement of the scriptures we might have hope.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The apostle Peter agrees with Paul that Christians are to use the Old Testament. He writes to the dispersed Christians, “It was revealed to them [the prophets] that they were serving not themselves but you, in regard to the things that have now been announced to you …” (1 Pet 1:12). Every Christian church today needs to hear the Old Testament for its function of teaching, reproof, correction, and training in righteousness, as well as for the hope it brings and the instruction it offers for “salvation through faith in Christ Jesus” (2 Tim 3:15).")]), _vm._v(" "), _c('h1', {
    staticClass: "sec3",
    attrs: {
      "id": "sec3-16"
    }
  }, [_c('strong', [_c('em', [_vm._v("The Old Testament Discloses the History of Redemption Leading to Christ")])])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("The second reason for preaching from the Old Testament is that it reveals the long history of redemption which culminates in the coming of Jesus Christ."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn71",
      "id": "fn-71"
    }
  }, [_vm._v("71")])]), _vm._v(" The Old Testament discloses God’s acts of redemption in a history that stretches from the creation to just prior to the coming of Christ. "), _c('a', {
    attrs: {
      "id": "page_27"
    }
  }, [_vm._v("It reveals how God, after the fall into sin, seeks to save his people and restore his kingdom (rule) on earth. It reveals God’s redemptive acts over many centuries as well as God’s promises and their fulfillments. We do not find this long history of God’s acts of salvation in the New Testament; it simply assumes and builds on this history. Since only the Old Testament reveals this redemptive history, it is indispensable for the Christian church.")])]), _c('a', {
    attrs: {
      "id": "page_27"
    }
  }, [_c('p', {
    staticClass: "indent-para"
  }, [_vm._v("We can liken redemptive history to a drama with many acts. The first act shows God creating a beautiful kingdom where he will be honored as King. The second act is about an attempted coup in the kingdom when human beings join Satan and rebel against God. It ends not only with God’s punishment of death but also with God’s assurance that he will not give up on his kingdom, for God breaks up the evil alliance and sets enmity between the “seed of the woman” and the seed of the evil one. Act 2 is followed by countless acts in which God saves his people. A high point is the call of Abraham in which God promises him many offspring, land, and (note God’s universal design) “in you all the families of the earth shall be blessed” (Gen 12:3; cf. Isa 2:3 = Mic 4:2). Other high points are the exodus from Egypt, the rule of King David, and the return of the exiles. But still the climax has not been reached. The climax comes in the New Testament with God sending his own Son to save the world. Accordingly, just as one cannot understand the last act of a drama without knowing the earlier acts, so this climactic act of God sending his Son cannot be understood without knowing the foregoing acts of God. Since these acts are recorded only in the Old Testament, preaching the Old Testament story is indispensable for the Christian church.")]), _vm._v(" "), _c('h1', {
    staticClass: "sec3",
    attrs: {
      "id": "sec3-17"
    }
  }, [_c('strong', [_c('em', [_vm._v("The Old Testament Proclaims Truths Not Found in the New Testament")])])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("A third reason for preaching from the Old Testament is that it reveals truths we know from no other source. When Jesus was asked which was the great commandment of the law, he could use the Old Testament to show that it was the love commandment (Mark 12:29-32). But the New Testament does not repeat everything the Old Testament teaches; it can simply assume Old Testament teaching because it was accepted as God’s word.")])]), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_27"
    }
  }, [_vm._v("For example, only in the Old Testament do we receive the comprehensive revelation of God as the sovereign Creator, wholly other than his creation yet involved in it. Only in the Old Testament do we learn that God created human beings in his image for fellowship with him and with each other, and with the mandate to develop and care for the earth. Only ")]), _c('a', {
    attrs: {
      "id": "page_28"
    }
  }, [_vm._v("in the Old Testament do we receive a picture of the human fall into sin, resulting in death, brokenness, and enmity between the seed of the woman and the seed of the serpent. Only in the Old Testament do we hear of God electing Abraham/Israel as a beachhead for restoring his kingdom on earth. Only in the Old Testament do we find details about God’s covenant with Israel, the ten words of the covenant (Decalogue), the blessings and the curses. Only in the Old Testament do we hear of the coming Messiah and the Day of the Lord.")])]), _c('a', {
    attrs: {
      "id": "page_28"
    }
  }, [_c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The various teachings of the Old Testament are sufficient to form a comprehensive worldview, namely, the interrelationship between God, human beings, and the world.")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/28.jpg"
    }
  })])]), _c('p', {
    staticClass: "para1"
  }, [_c('a', {
    attrs: {
      "id": "page_28"
    }
  }, [_vm._v("A worldview is crucial, for it acts as a grid which sorts and interprets information and helps us make sense of the world and our place and task in it."), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/#fn72",
      "id": "fn-72"
    }
  }, [_vm._v("72")]), _vm._v(" The Old Testament worldview is quite distinct from other world-views such as polytheism, pantheism, gnosticism, deism, atheism, and naturalism. The New Testament does not provide another worldview but simply assumes the one taught in the Old Testament.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Besides these foundational teachings, the Old Testament offers a host of other teachings which may or may not be echoed in the New Testament. Some of these are the sovereignty of God over all nations (Isa 10:5-19; Habakkuk), the incomparability of God (Isa 40:12-31), the problem of the suffering of God’s people (Job, Psalms), human responsibility for promoting social justice (Deuteronomy 15, Amos, Micah, Isaiah), the gift of sexual love (Gen 2:18-28; Song of Songs), and a hopeful view of the new earth (Isa 11:6-9; 65:17-25). Bereft of these Old Testament teachings, preaching becomes anemic. Michael Duduit judges, “For us to neglect these books in our preaching is to abandon our congregations to theological shallowness and mediocrity.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn73",
      "id": "fn-73"
    }
  }, [_vm._v("73")])])]), _vm._v(" "), _c('h1', {
    staticClass: "sec3",
    attrs: {
      "id": "sec3-18"
    }
  }, [_c('strong', [_c('em', [_c('a', {
    attrs: {
      "id": "page_29"
    }
  }, [_vm._v("The Old Testament Helps Us to Understand the New Testament")])])])]), _c('a', {
    attrs: {
      "id": "page_29"
    }
  }, [_c('p', {
    staticClass: "para"
  }, [_vm._v("The night before Jesus’ death, he celebrated the Passover with his disciples. But a strange thing happened. Matthew tells us that Jesus took a cup and said, “This is my blood of the covenant, which is poured out for many for the forgiveness of sins” (26:28). We may have heard these words so often that we do not find them strange anymore, but what is this talk about “blood” and “covenant”? We would never know unless we knew the Old Testament teaching about Passover and about God’s covenant with his people and the blood sacrifices required to atone for their sins.")])]), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_29"
    }
  }, [_vm._v("Or consider the concept of church. Without the Old Testament we cannot know what the church is, for the New Testament describes the church in images from the Old Testament. Paul portrays the church as “the temple of the living God” (2 Cor 6:16) and “the Israel of God” (Gal 6:16). Peter also describes the church in Old Testament concepts: “a chosen race, a royal priesthood, a holy nation, God’s own people, in order that you may proclaim the mighty acts [the praises, NIV] of him who called you out of darkness into his marvelous light” (1 Pet 2:9). Even the way Peter describes the task of the church derives from the Old Testament, where we read: “The people whom I formed for myself so that they might declare my praise” (Isa 43:21). When Jesus gave his church the great commission to “make disciples of all nations” (Matt 28:18-20), he reiterated the task of Israel: “I will give you as a light to the nations, that my salvation may reach the end of the earth” (Isa 49:6; cf. Gen 12:3). John Bright’s summary reveals many of these Old Testament concepts: “The New Testament understood … [the church] as the true Israel, God’s covenant and servant people, called to exhibit the righteousness of his Kingdom before the world, charged with proclaiming that Kingdom in the world and summoning men to its covenant fellowship.”"), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/#fn74",
      "id": "fn-74"
    }
  }, [_vm._v("74")])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The New Testament is filled with many other images and concepts whose meaning we cannot know without the Old Testament. Think, for example, of such concepts as God, the kingdom of God, salvation, prophet, priest, king, atonement, law, faith, hope, love, Christ, Son of Man, good shepherd, and servant of God. Preaching from the Old Testament, therefore, helps a congregation understand the New Testament.")]), _vm._v(" "), _c('h1', {
    staticClass: "sec3",
    attrs: {
      "id": "sec3-19"
    }
  }, [_c('strong', [_c('em', [_c('a', {
    attrs: {
      "id": "page_30"
    }
  }, [_vm._v("The Old Testament Prevents Misunderstanding the New Testament")])])])]), _c('a', {
    attrs: {
      "id": "page_30"
    }
  }, [_c('p', {
    staticClass: "para"
  }, [_vm._v("An even more important reason for preaching from the Old Testament is that it prevents misunderstanding the New Testament. For example, the first thing we read about Jesus’ ministry is that he began to preach, “Repent, for the kingdom of heaven has come near” (Matt 4:17). What is “the kingdom of heaven”? Without the Old Testament we wonder: Is this a kingdom in heaven, far away from this evil world? We seem to find confirmation of this view later when Jesus says to Pilate, “My kingdom is not of this world” (John 18:36, NIV). Consequently, many Christians look forward to escaping this wicked world and occupying their “mansion in heaven.” Without realizing it, they have adopted the Marcionistic/Gnostic view of salvation, which is to escape from this evil, material world. But is Jesus really saying that his kingdom is in heaven only?")])]), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_30"
    }
  }, [_vm._v("F. F. Bruce writes that Jesus “used language which must have rung a loud bell, or several loud bells, in the minds of those hearers who had some consciousness of their people’s heritage [the Old Testament]. The kingship of Yahweh, the God of Israel, had been for centuries a dominant theme in the national worship …. Yahweh’s mighty acts in creation and history alike prefigured that coming day when He would be obeyed as King over all the earth.”"), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/#fn75",
      "id": "fn-75"
    }
  }, [_vm._v("75")]), _vm._v(" According to the clear expectation of the Old Testament, God’s kingdom (reign) would be returning to this "), _c('em', [_vm._v("earth.")]), _vm._v(" Did Jesus change this expectation from earth to heaven? A clearer translation of Jesus’ words to Pilate is, “My kingdom is not "), _c('em', [_vm._v("from")]), _vm._v(" this world” (John 18:36, NRSV), implying that Jesus’ kingdom originates in heaven. But Jesus continues the Old Testament expectation that the kingdom of heaven (= kingdom of God) is coming to this earth. In fact, with his presence and miracles, Jesus says, “the kingdom of God has come to you” (Luke 11:20). But it is not yet complete. Therefore Jesus teaches his people to pray, “Your kingdom come. Your will be done, on "), _c('em', [_vm._v("earth")]), _vm._v(" as it is in heaven” (Matt 6:10). When Jesus comes again — and that will be the final act in this redemptive drama — he will bring God’s perfect kingdom to this earth. “In accordance with his promise, we wait for new heavens and a new earth, where righteousness is at home” (2 Pet 3:13; cf. Rev 21:1).")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Clearly, one of the dangers of reading the New Testament without its Old Testament background is a serious misunderstanding of the teaching of the New Testament. Marvin Wilson has written a sobering chapter on “Where the Church Went Wrong.” He notes that “the Church paid little heed to the exhortation of Paul to continue in what it had learned and "), _c('a', {
    attrs: {
      "id": "page_31"
    }
  }, [_vm._v("believed in the context of its Hebrew beginnings. Rather, as it became more and more Hellenized …, it began to be led away into strange teachings (cf. Heb. 13:9).”"), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/#fn76",
      "id": "fn-76"
    }
  }, [_vm._v("76")]), _vm._v(" At the root of these strange teachings lay a Greek dualistic way of thinking (worldview) which held to a higher, invisible spiritual world and an inferior, visible material world. These two worlds, it was thought, are also present in each person as the higher, spiritual soul and the lower, material body. According to Plato, the body is the prison of the soul, and salvation is the escape of the soul at death to the realm of pure spirit. Reading the New Testament through these dualistic glasses, the church at various times devalued the material world and our human bodies by promoting asceticism (though rejected by Paul — Col 2:20-23), celibacy, otherworldliness, and salvation as escape from the world."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn77",
      "id": "fn-77"
    }
  }, [_vm._v("77")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("A. J. B. Higgins observes, “We have in Marcion’s treatment a perfect example of what can happen to the New Testament when the Old is cast on one side as of little or no importance for Christianity.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn78",
      "id": "fn-78"
    }
  }, [_vm._v("78")])]), _vm._v(" Marcion may have been rejected by the church, but his dualistic views keep cropping up to the present day. “In various ways this old enemy [gnosticism] has returned in various guises: new age religion, various eastern religions, but also in the church itself …. If we present a Christian faith that is of no earthly use, that has no implications for the practice of life in every realm, and that has no demonstration of the power of the gospel to renew life here and now, then we have succumbed to a future-oriented gnostic reduction of the gospel.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn79",
      "id": "fn-79"
    }
  }, [_vm._v("79")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Since we all have our presuppositions and prejudices, no one can claim to have a perfect understanding of the New Testament. But there is one presupposition that is indispensable for a good interpretation of the New Testament. That presupposition is the unity of the Bible and, therefore, the necessity of understanding the New Testament in the context of "), _c('a', {
    attrs: {
      "id": "page_32"
    }
  }, [_vm._v("the Old, and vice versa. “The Old Testament holds the gospel to history. It is the surest bulwark against assimilation with alien philosophies and ideologies, against a flight into a sentimental and purely otherworldly piety, and against that disintegrating individualism that so easily besets us.”"), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/#fn80",
      "id": "fn-80"
    }
  }, [_vm._v("80")])]), _vm._v(" "), _c('h1', {
    staticClass: "sec3",
    attrs: {
      "id": "sec3-20"
    }
  }, [_c('strong', [_c('em', [_vm._v("The Old Testament Provides a Fuller Understanding of Christ")])])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("A final reason for preaching from the Old Testament is that it provides a fuller understanding of the person, work, and teaching of Christ than does preaching only from the New Testament. For Jesus not only taught that the Old Testament witnessed to him, but in his life he also lived out of, fulfilled, and taught the Scriptures. A discussion of this reason, however, is more appropriate at the end of the next chapter.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/foot.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn-1",
      "id": "fn1"
    }
  }, [_vm._v("1")]), _vm._v(". Grasso, "), _c('em', [_vm._v("Proclaiming,")]), _vm._v(" 6.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn-2",
      "id": "fn2"
    }
  }, [_vm._v("2")]), _vm._v(". Florovsky, "), _c('em', [_vm._v("Bible,")]), _vm._v(" 9.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn-3",
      "id": "fn3"
    }
  }, [_vm._v("3")]), _vm._v(". Reu, "), _c('em', [_vm._v("Homiletics,")]), _vm._v(" 57.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn-4",
      "id": "fn4"
    }
  }, [_vm._v("4")]), _vm._v(". Hoekstra, "), _c('em', [_vm._v("Homiletiek,")]), _vm._v(" 172 (my translation). Cf. Abraham Kuyper, quoted by C. Veenhof, "), _c('em', [_vm._v("Predik,")]), _vm._v(" 20 (my translation), “Believers rightly require that every sermon present the Christ.”")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn-5",
      "id": "fn5"
    }
  }, [_vm._v("5")]), _vm._v(". Spurgeon, "), _c('em', [_vm._v("Lectures to My Students,")]), _vm._v(" 194.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn-6",
      "id": "fn6"
    }
  }, [_vm._v("6")]), _vm._v(". See also, e.g., James Stewart, "), _c('em', [_vm._v("Heralds,")]), _vm._v(" 54, “If we are not determined that in every sermon Christ is to be preached, it were better that we should resign our commission forthwith and seek some other vocation.” R. B. Kuiper, “Scriptural Preaching,” 239, “Truly Scriptural preaching, therefore, cannot but be christocentric.” Edmund Clowney, "), _c('em', [_vm._v("Preaching and Biblical Theology,")]), _vm._v(" 74, “He who would preach the Word must preach Christ.” Jay Adams, "), _c('em', [_vm._v("Preaching with Purpose,")]), _vm._v(" 152, “Preach Christ in all the Scriptures: He is the subject matter of the whole Bible. He is there. Until you have found Him in your preaching portion, you are not ready to preach.” David Larsen, "), _c('em', [_vm._v("Anatomy of Preaching,")]), _vm._v(" 163, “The Christian proclaimer, whether preaching from the Old Testament or the New, must present Christ as the ultimate frame of reference.”")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn-7",
      "id": "fn7"
    }
  }, [_vm._v("7")]), _vm._v(". Note a similar confusion in systematic theology. “Theologians as different from each other as Luther and Socinus, Karl Barth and Paul Tillich speak of Christ being the center of the Scriptures,” but what they mean by this is different for each. Robert D. Preus, “A Response to the Unity of the Bible,” 677.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn-8",
      "id": "fn8"
    }
  }, [_vm._v("8")]), _vm._v(". William Robinson, “Jesus Christ Is Jehovah,” "), _c('em', [_vm._v("EvQ")]), _vm._v(" 5 (1933) 145. Cf. T. W. Calloway, "), _c('em', [_vm._v("Christ in the Old Testament")]), _vm._v(" (New York: Loizeaux, 1950), e.g., chap. 1, “‘Jehovah’ of the Old Testament the Christ of the New.” Also Howard A. Hanke, "), _c('em', [_vm._v("Christ and the Church in the Old Testament")]), _vm._v(" (Grand Rapids: Zondervan, 1957), e.g., p. 173, “In the Old Testament our Lord was revealed to man under the name of Christ (Jehovah); in the New Testament He revealed Himself in the name of Yahshua or Christ (Jesus).”")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn-9",
      "id": "fn9"
    }
  }, [_vm._v("9")]), _vm._v(". Lischer, "), _c('em', [_vm._v("Theology of Preaching,")]), _vm._v(" 73.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn-10",
      "id": "fn10"
    }
  }, [_vm._v("10")]), _vm._v(". Dodd, "), _c('em', [_vm._v("Apostolic Preaching,")]), _vm._v(" 38-43.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn-11",
      "id": "fn11"
    }
  }, [_vm._v("11")]), _vm._v(". Reu, "), _c('em', [_vm._v("Homiletics,")]), _vm._v(" 59.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn-12",
      "id": "fn12"
    }
  }, [_vm._v("12")]), _vm._v(". John Knox, "), _c('em', [_vm._v("Chapters,")]), _vm._v(" 126.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn-13",
      "id": "fn13"
    }
  }, [_vm._v("13")]), _vm._v(". Stewart, "), _c('em', [_vm._v("Faith to Proclaim,")]), _vm._v(" 98.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn-14",
      "id": "fn14"
    }
  }, [_vm._v("14")]), _vm._v(". Knox, "), _c('em', [_vm._v("Chapters,")]), _vm._v(" 109. Cf. Stewart, "), _c('em', [_vm._v("Faith to Proclaim,")]), _vm._v(" 111, “‘Knowing Christ’ means here what it means regularly in Paul: the primary reference is not to the Jesus of history but to the exalted, ever present Lord …. to preach ‘Christ and Him crucified’ is emphatically a Resurrection "), _c('em', [_vm._v("kerygma.")]), _vm._v("”")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn-15",
      "id": "fn15"
    }
  }, [_vm._v("15")]), _vm._v(". Stewart, "), _c('em', [_vm._v("Heralds,")]), _vm._v(" 89.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn-16",
      "id": "fn16"
    }
  }, [_vm._v("16")]), _vm._v(". J. Kahmann, "), _c('em', [_vm._v("Bible,")]), _vm._v(" 82. Cf. Raymond Brown, "), _c('em', [_vm._v("Biblical Exegesis,")]), _vm._v(" 141, “If one cannot understand the resurrection properly without the cross, one cannot understand either the cross or the resurrection without understanding the Jesus who reached out to heal the sick … who proclaimed God’s blessing to the poor and the oppressed.”")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn-17",
      "id": "fn17"
    }
  }, [_vm._v("17")]), _vm._v(". It was proclaiming these events, too, of course. See, e.g., 1 Cor 15:12-20 and 2 Pet 1:16. “It was the announcement of certain concrete facts of history, the heralding of real, objective events. Its keynote was, ‘That which we have seen and heard declare we unto you.’” Stewart, "), _c('em', [_vm._v("Heralds,")]), _vm._v(" 62-64.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn-18",
      "id": "fn18"
    }
  }, [_vm._v("18")]), _vm._v(". For example, Paul marveled that to him was given the grace “to preach to the Gentiles the unsearchable riches of Christ” (Eph 3:8, NIV).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn-19",
      "id": "fn19"
    }
  }, [_vm._v("19")]), _vm._v(". Note Paul’s emphasis (repetition) in 1 Corinthians 15 on “in accordance with the scriptures.”")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn-20",
      "id": "fn20"
    }
  }, [_vm._v("20")]), _vm._v(". Stewart, "), _c('em', [_vm._v("Heralds,")]), _vm._v(" 64.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn-21",
      "id": "fn21"
    }
  }, [_vm._v("21")]), _vm._v(". See G. C. Berkouwer, "), _c('em', [_vm._v("Person of Christ,")]), _vm._v(" 101-6.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn-22",
      "id": "fn22"
    }
  }, [_vm._v("22")]), _vm._v(". “Not to know who he is means: not to understand what his work is; and not to see his work in the right perspective is not to understand his person …. Therefore the revelation of God illumines both Christ’s person and work.” Berkouwer, ibid., 105.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn-23",
      "id": "fn23"
    }
  }, [_vm._v("23")]), _vm._v(". Perhaps in reaction to liberal theology and social gospel preaching in the early 1900s with its almost exclusive focus on the "), _c('em', [_vm._v("teaching")]), _vm._v(" of Christ. See Meade Williams, "), _c('em', [_vm._v("Princeton Theological Review")]), _vm._v(" 4 (1906) 191-95.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn-24",
      "id": "fn24"
    }
  }, [_vm._v("24")]), _vm._v(". Reading biblical description as biblical prescription is a common form of the genre mistake, i.e., reading the genre of historical or autobiographical narrative as if it were the genre of law or exhortation. See my "), _c('em', [_vm._v("Modern Preacher,")]), _vm._v(" 17, 165.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn-25",
      "id": "fn25"
    }
  }, [_vm._v("25")]), _vm._v(". John 14:6; cf. John 15:5; 17; Matt 11:27; 2 Cor 5:20-21; 2 Tim 2:5.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn-26",
      "id": "fn26"
    }
  }, [_vm._v("26")]), _vm._v(". See, e.g., Allan Harman, “No Other Name,” "), _c('em', [_vm._v("Theological Forum")]), _vm._v(" 24 (November 1996) 43-53.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn-27",
      "id": "fn27"
    }
  }, [_vm._v("27")]), _vm._v(". Stott, "), _c('em', [_vm._v("Between Two Worlds,")]), _vm._v(" 154.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn-28",
      "id": "fn28"
    }
  }, [_vm._v("28")]), _vm._v(". "), _c('em', [_vm._v("Ibid")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn-29",
      "id": "fn29"
    }
  }, [_vm._v("29")]), _vm._v(". Reu, "), _c('em', [_vm._v("Homiletics,")]), _vm._v(" 57.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn-30",
      "id": "fn30"
    }
  }, [_vm._v("30")]), _vm._v(". Stott, "), _c('em', [_vm._v("Between Two Worlds,")]), _vm._v(" 325.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn-31",
      "id": "fn31"
    }
  }, [_vm._v("31")]), _vm._v(". Hull, “Called to Preach,” 47-48.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn-32",
      "id": "fn32"
    }
  }, [_vm._v("32")]), _vm._v(". Thomas Ridenhour, “Old Testament and Preaching,” 254.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn-33",
      "id": "fn33"
    }
  }, [_vm._v("33")]), _vm._v(". Criswell, “Preaching from the Old Testament,” 293.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn-34",
      "id": "fn34"
    }
  }, [_vm._v("34")]), _vm._v(". Gleason L. Archer Jr., “A New Look at the Old Testament,” "), _c('em', [_vm._v("Decision,")]), _vm._v(" August 1972, 5.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn-35",
      "id": "fn35"
    }
  }, [_vm._v("35")]), _vm._v(". Cf. Herbert Mayer, “The Old Testament in the Pulpit,” "), _c('em', [_vm._v("CTM")]), _vm._v(" 35 (1964) 603, “The Lutheran Church — Missouri Synod reveals an average of four or five New Testament studies for each Old Testament text.” Cf. John Stapert, "), _c('em', [_vm._v("Church Herald")]), _vm._v(" [Reformed Church in America], July 13, 1979, 9, “The great majority of the sermons I have heard were exclusively or almost exclusively from the New Testament.”")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn-36",
      "id": "fn36"
    }
  }, [_vm._v("36")]), _vm._v(". Michael Duduit, “The Church’s Need for Old Testament Preaching,” 10.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn-37",
      "id": "fn37"
    }
  }, [_vm._v("37")]), _vm._v(". McCurley, "), _c('em', [_vm._v("Proclaiming,")]), _vm._v(" 3. Presenting a few lectures in Norway in 1997, I was surprised to discover that the Lutheran church in Norway did not really preach from the Old Testament until the 1980s, when two Old Testament passages were placed on their lectionary.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn-38",
      "id": "fn38"
    }
  }, [_vm._v("38")]), _vm._v(". Calvin Storley, “Reclaiming the Old Testament,” 490.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn-39",
      "id": "fn39"
    }
  }, [_vm._v("39")]), _vm._v(". Olson, “Rediscovering,” 3.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn-40",
      "id": "fn40"
    }
  }, [_vm._v("40")]), _vm._v(". Herbert F. Hahn, "), _c('em', [_vm._v("The Old Testament in Modern Research")]), _vm._v(" (Philadelphia: Fortress, 1966), 10.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn-41",
      "id": "fn41"
    }
  }, [_vm._v("41")]), _vm._v(". Wellhausen as cited in Alfred Jepsen, “The Scientific Study of the Old Testament,” in "), _c('em', [_vm._v("Essays on Old Testament Hermeneutics,")]), _vm._v(" ed. Claus Westermann (Richmond, VA: John Knox, 1964), 247, my emphasis.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn-42",
      "id": "fn42"
    }
  }, [_vm._v("42")]), _vm._v(". Von Rad, “Gerhard von Rad über von Rad,” in "), _c('em', [_vm._v("Probleme biblischer Theologie,")]), _vm._v(" ed. H. W. Wolff (Munich, 1971), 660, as cited in Rendtorff, "), _c('em', [_vm._v("Canon,")]), _vm._v(" 76.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn-43",
      "id": "fn43"
    }
  }, [_vm._v("43")]), _vm._v(". See my "), _c('em', [_vm._v("Modern Preacher,")]), _vm._v(" 55-79.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn-44",
      "id": "fn44"
    }
  }, [_vm._v("44")]), _vm._v(". A. J. B. Higgins, "), _c('em', [_vm._v("Christian Significance of the Old Testament,")]), _vm._v(" 14.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn-45",
      "id": "fn45"
    }
  }, [_vm._v("45")]), _vm._v(". On the debate regarding Marcion’s dependence on gnosticism, see John Bright, "), _c('em', [_vm._v("Authority,")]), _vm._v(" 62, n. 4.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn-46",
      "id": "fn46"
    }
  }, [_vm._v("46")]), _vm._v(". The church may well have changed the order of the Hebrew Bible from Torah–Prophets–Writings to Torah–Writings–Prophets in order to express this unity of the two Testaments by highlighting that Christ is the fulfillment of Old Testament prophecy. But scholars are not agreed on this point. Otto Eissfeldt, "), _c('em', [_vm._v("The Old Testament: An Introduction,")]), _vm._v(" trans. Peter R. Ackroyd (New York: Harper and Row, 1965), 570, claims that this change took place in “the tradition represented in LXX …. The arrangements of the books here is clearly determined by the principle that there stand first the historical books which deal with the past, then the poetic and didactic writings, understood as being in a special sense books of edification and instruction for contemporary life, and the prophetic writings directed towards the future provide the ending.”")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn-47",
      "id": "fn47"
    }
  }, [_vm._v("47")]), _vm._v(". This Council, probably held in Rome, “gave a complete list of the canonical books of both the OT and the NT (also known as the ‘Gelasian Decree’ because it was reproduced by Gelasius in 495) which is identical with the list given at the Council of Trent.” "), _c('em', [_vm._v("The Oxford Dictionary of the Christian Church")]), _vm._v(" (3d ed.; New York: Oxford University Press, 1997), 279.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn-48",
      "id": "fn48"
    }
  }, [_vm._v("48")]), _vm._v(". See, e.g., A. H. J. Gunneweg, "), _c('em', [_vm._v("Understanding the Old Testament;")]), _vm._v(" Emil G. Kraeling, "), _c('em', [_vm._v("The Old Testament since the Reformation;")]), _vm._v(" Foster McCurley, "), _c('em', [_vm._v("Proclaiming the Promise;")]), _vm._v(" and Alan Richardson, “Is the Old Testament the Propaedeutic to Christian Faith?”")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn-49",
      "id": "fn49"
    }
  }, [_vm._v("49")]), _vm._v(". Kraeling, "), _c('em', [_vm._v("Old Testament,")]), _vm._v(" 59.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn-50",
      "id": "fn50"
    }
  }, [_vm._v("50")]), _vm._v(". Schleiermacher, "), _c('em', [_vm._v("The Christian Faith,")]), _vm._v(" 60-62, as cited in McCurley, "), _c('em', [_vm._v("Proclaiming the Promise,")]), _vm._v(" 9.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn-51",
      "id": "fn51"
    }
  }, [_vm._v("51")]), _vm._v(". Kraeling, "), _c('em', [_vm._v("Old Testament,")]), _vm._v(" 66.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn-52",
      "id": "fn52"
    }
  }, [_vm._v("52")]), _vm._v(". Ibid.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn-53",
      "id": "fn53"
    }
  }, [_vm._v("53")]), _vm._v(". Ibid., 148.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn-54",
      "id": "fn54"
    }
  }, [_vm._v("54")]), _vm._v(". Ibid., 149.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn-55",
      "id": "fn55"
    }
  }, [_vm._v("55")]), _vm._v(". Harnack, "), _c('em', [_vm._v("Marcion: Das Evangelium vom fremden Gott")]), _vm._v(" (1924), 221-22. Quotation taken from Bright, "), _c('em', [_vm._v("Authority,")]), _vm._v(" 65.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn-56",
      "id": "fn56"
    }
  }, [_vm._v("56")]), _vm._v(". See Bright, "), _c('em', [_vm._v("Authority,")]), _vm._v(" 67-75.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn-57",
      "id": "fn57"
    }
  }, [_vm._v("57")]), _vm._v(". See, e.g., Bernard Anderson in his “Introduction” to "), _c('em', [_vm._v("The Old Testament and Christian Faith")]), _vm._v(" (New York: Harper & Row, 1963), 7; and in the same volume, Carl Michaelson, “Bultmann against Marcion,” 49-63.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn-58",
      "id": "fn58"
    }
  }, [_vm._v("58")]), _vm._v(". Bultmann, “Significance,” 17. Cf. pp. 34-35: “If … the Old Testament is taken up into the Church’s proclamation as God’s word, then the inviolable conditions are: (1) that the Old Testament is used in its original sense …; (2) that the Old Testament is adopted only in so far as it is actually promise — that is, preparation for the Christian understanding of existence.” Cf. Friedrich Baumgärtel, “The Hermeneutical Problem of the Old Testament,” in "), _c('em', [_vm._v("Essays on Old Testament Hermeneutics,")]), _vm._v(" 135, “For this understanding we cannot eliminate the fact, derived from study of the history of religion, that the Old Testament is a witness out of a non-Christian religion ….”")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn-59",
      "id": "fn59"
    }
  }, [_vm._v("59")]), _vm._v(". Ibid., 31-32.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn-60",
      "id": "fn60"
    }
  }, [_vm._v("60")]), _vm._v(". For example, in August 1962, the London "), _c('em', [_vm._v("Times")]), _vm._v(" published a series of letters regarding the reading of the Old Testament in public worship. Dr. Leslie Weatherhead, Minister Emeritus of London’s City Temple, wrote, “Again and again, one would like to rise in church after the Old Testament lesson and say, ‘My dear friends, do not pay any heed to the irrelevant nonsense which has just been read to you. It has no bearing whatever on the Christian religion.’” See "), _c('em', [_vm._v("Christianity Today,")]), _vm._v(" September 28, 1962, 54.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn-61",
      "id": "fn61"
    }
  }, [_vm._v("61")]), _vm._v(". Bright, "), _c('em', [_vm._v("Authority,")]), _vm._v(" 74.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn-62",
      "id": "fn62"
    }
  }, [_vm._v("62")]), _vm._v(". Gowan, "), _c('em', [_vm._v("Reclaiming,")]), _vm._v(" 6.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn-63",
      "id": "fn63"
    }
  }, [_vm._v("63")]), _vm._v(". Kaiser, "), _c('em', [_vm._v("Exegetical Theology,")]), _vm._v(" 37.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn-64",
      "id": "fn64"
    }
  }, [_vm._v("64")]), _vm._v(". For some suggestions and references, see my "), _c('em', [_vm._v("Modern Preacher,")]), _vm._v(" 157-87.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn-65",
      "id": "fn65"
    }
  }, [_vm._v("65")]), _vm._v(". Marcion, as recounted by Tertullian, "), _c('em', [_vm._v("Against Marcion,")]), _vm._v(" respectively 2.18, 4.23, and 3.21, as quoted by Higgins, "), _c('em', [_vm._v("Christian Significance,")]), _vm._v(" 16.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn-66",
      "id": "fn66"
    }
  }, [_vm._v("66")]), _vm._v(". Ibid., 4.16, as quoted by Higgins, "), _c('em', [_vm._v("Christian Significance,")]), _vm._v(" 16.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn-67",
      "id": "fn67"
    }
  }, [_vm._v("67")]), _vm._v(". On the so-called “imprecatory Psalms,” see "), _c('span', {
    attrs: {
      "href": "#/013_Chapter06#page_274",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("pp. 274-75")]), _vm._v(" below. Also see Walter Kaiser, "), _c('em', [_vm._v("Old Testament Ethics,")]), _vm._v(" 292-97.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn-68",
      "id": "fn68"
    }
  }, [_vm._v("68")]), _vm._v(". Bright, "), _c('em', [_vm._v("Authority,")]), _vm._v(" 77-78.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn-69",
      "id": "fn69"
    }
  }, [_vm._v("69")]), _vm._v(". McCurley, "), _c('em', [_vm._v("Proclaiming,")]), _vm._v(" 5.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn-70",
      "id": "fn70"
    }
  }, [_vm._v("70")]), _vm._v(". Some of these explanations were gleaned from Kaiser, "), _c('em', [_vm._v("Rediscovering,")]), _vm._v(" 26-32.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn-71",
      "id": "fn71"
    }
  }, [_vm._v("71")]), _vm._v(". Although the Old Testament contains a rich treasure of biblical truths (doctrines), we should first consider redemptive history. For redemptive history precedes biblical doctrines. Redemptive history, we could say, forms the indispensable foundation of biblical doctrine.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn-72",
      "id": "fn72"
    }
  }, [_vm._v("72")]), _vm._v(". See Albert M. Wolters, "), _c('em', [_vm._v("Creation Regained: Biblical Basis for a Reformational Worldview")]), _vm._v(" (Grand Rapids: Eerdmans, 1985).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn-73",
      "id": "fn73"
    }
  }, [_vm._v("73")]), _vm._v(". Duduit, “Church’s Need,” 12. See also Achtemeier, "), _c('em', [_vm._v("Preaching,")]), _vm._v(" 21-26.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn-74",
      "id": "fn74"
    }
  }, [_vm._v("74")]), _vm._v(". Bright, "), _c('em', [_vm._v("Kingdom,")]), _vm._v(" 259.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn-75",
      "id": "fn75"
    }
  }, [_vm._v("75")]), _vm._v(". Bruce, "), _c('em', [_vm._v("New Testament Development,")]), _vm._v(" 22, 24.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn-76",
      "id": "fn76"
    }
  }, [_vm._v("76")]), _vm._v(". Wilson, "), _c('em', [_vm._v("Our Father Abraham,")]), _vm._v(" 166.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn-77",
      "id": "fn77"
    }
  }, [_vm._v("77")]), _vm._v(". Wilson, ibid., 173, writes, “The Scriptures view both humanity and the world in terms of dynamic unity, not dualistically. But gradually unwholesome and unbiblical attitudes became embedded in Christian thought. Consequently, the Church’s perspective on the enjoying of material and physical pleasures, and on the affirming of the goodness of marriage and the family, became distorted ….” On pp. 182-90 Wilson deals with the Western view of faith as intellectual assent instead of faithfulness or trust, and individualism at the cost of community.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn-78",
      "id": "fn78"
    }
  }, [_vm._v("78")]), _vm._v(". Higgins, "), _c('em', [_vm._v("Christian Significance,")]), _vm._v(" 21. Cf. D. Moody Smith, “Where the Old Testament is ignored, such an understanding of man as creature, indeed as historical and societal creature, usually disappears, and the New Testament is wrongly regarded as only a handbook of personal piety and religion.” “The Use of the Old Testament,” 65.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn-79",
      "id": "fn79"
    }
  }, [_vm._v("79")]), _vm._v(". Raymond Van Leeuwen, “No Other Gods,” 42.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn-80",
      "id": "fn80"
    }
  }, [_vm._v("80")]), _vm._v(". Bright, "), _c('em', [_vm._v("Authority,")]), _vm._v(" 78.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-587f1ea5","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/008_Chapter01.vue
// module id = 78
// module chunks = 0